/**
 * JSON-LD por rota.
 *
 * O index.html carrega o schema fixo do site (Organization, WebSite,
 * SoftwareApplication). Páginas que ganham rich result próprio — FAQ,
 * breadcrumb, produto — injetam o seu aqui e removem ao sair, para nunca
 * sobrar o schema de uma página na outra (o Google trata schema órfão
 * como marcação enganosa e pode punir o rich result).
 *
 * Cada bloco é identificado por `id`, então re-render só atualiza o
 * conteúdo em vez de empilhar <script>.
 */
import { useEffect } from 'react';

export function useJsonLd(id: string, data: unknown): void {
  // Serializa fora do effect: objeto novo a cada render dispararia o
  // effect sempre, mas o JSON dele costuma ser idêntico.
  const json = JSON.stringify(data);

  useEffect(() => {
    const elId = `jsonld-${id}`;
    let el = document.getElementById(elId) as HTMLScriptElement | null;
    if (!el) {
      el = document.createElement('script');
      el.id = elId;
      el.type = 'application/ld+json';
      document.head.appendChild(el);
    }
    el.textContent = json;
    return () => {
      document.getElementById(elId)?.remove();
    };
  }, [id, json]);
}
